'use strict';
var formValidation = require('../components/formValidation');
const FOCUSABLE = 'button:not(:disabled):not([aria-hidden]),input, select';
// var moment = require('moment');
var moment = require('moment-timezone');
const navigationCountry = $('.page').attr('data-navigation-country');

if (navigationCountry === 'CN') {
    var TencentCaptcha = require('../common/tencentCaptcha');
}

function setButtonAttribute() {
    $('.selectpicker').selectpicker();
    $('.selectpicker').each(function() {
        $(this).css({
            display: 'none'
        });
        var label;
        // set button id for label
        if (this.labels.length > 0) {
            label = this.labels[0].innerText;
        } else {
            label = $(this).closest('.cc-form-group').find('.cc-label').html();
        }
        var $button = $(this).siblings('button');
        $button.attr('aria-label', label);
        $button.attr('tabindex', "0");
        setTabindexOnFocusout();
        $(this).selectpicker('refresh');
        // fix voice over
        $(this).parent().find('.dropdown-toggle').removeAttr('role');
        var $dropdown = $button.siblings('.dropdown-menu').children('.inner');
        $dropdown.attr('aria-label', label);
        $button.attr('role', 'combobox').attr('aria-activedescendant', '');
    });

    $('.dropdown-menu .inner').removeAttr('aria-activedescendant');
    var targets = $('button.dropdown-toggle').siblings('.dropdown-menu').children('.inner').removeAttr('aria-activedescendant').get();
    if (targets) {
        // create an observer instance
        targets.forEach(function(target) {
            var observer = new MutationObserver(function(mutations) {
                if (mutations.length) {
                    $(target).removeAttr('aria-activedescendant');
                }
            });
            var config = {
                attributes: true
            };

            // pass in the target node, as well as the observer options
            observer.observe(target, config);
        });
    };
};
function toIsoString (date, offSet) {
    var tzo;
    if (offSet) {
        var zoneHour, zoneMinutes;
        if (offSet.indexOf('+') !== -1) {
            if (offSet.indexOf('.') !== -1) {
                zoneHour = parseInt(offSet.split('.')[0], 10);
                zoneMinutes = parseInt(offSet.split('.')[1], 10);
                tzo = (zoneHour * 60) + zoneMinutes;
            } else {
                tzo = parseInt(offSet.split('+')[1]) * 60;
            }
        } else if (offSet.indexOf('-') !== -1) {
            if (offSet.indexOf('.') !== -1) {
                zoneHour = parseInt(offSet.split('.')[0], 10);
                zoneMinutes = parseInt(offSet.split('.')[1], 10);
                tzo = (-1) * (zoneHour * 60) + zoneMinutes;
            } else {
                tzo = (-1) * parseInt(offSet.split('-')[1]) * 60;
            }
        }
    } else {
        tzo = -date.getTimezoneOffset();
    }
    var dif = tzo >= 0 ? '+' : '-';
    var pad = function(num) {
        var norm = Math.floor(Math.abs(num));
        return (norm < 10 ? '0' : '') + norm;
    };

    return date.getFullYear() +
        '-' + pad(date.getMonth() + 1) +
        '-' + pad(date.getDate()) +
        'T' + pad(date.getHours()) +
        ':' + pad(date.getMinutes()) +
        ':' + pad(date.getSeconds()) + '.000' +
        dif + pad(tzo / 60) + pad(tzo % 60);
};
function trasformHour (startDate, zone) {
    var d = new Date(startDate);
    var zoneHour = zone;
    var zoneMinutes = '0';
    if (zone.toString().indexOf('.') !== -1) {
        zoneHour = zone.split('.')[0];
        zoneMinutes = zone.split('.')[1];
    }
    d.setHours(d.getHours() + +zoneHour);
    d.setUTCMinutes(d.getUTCMinutes() + +zoneMinutes);
    var minutes = (d.getUTCMinutes() !== 0) ? d.getUTCMinutes() : '00';
    var hour = d.getUTCHours() + ':' + minutes;
    return hour;
}
function checkDST (date, param) {
    var a = moment.tz(date, param);
    var minutes = (a.minutes() !== 0) ? a.minutes() : '00';
    var slotHour = a.hour() + ':' + minutes;
    var obj = {};
    obj.hour = slotHour;
    obj.zoneAbbr = a.zoneAbbr();
    obj.offset = a.format('Z').replace(':', '.');
    return obj;
};
function nextDateLabel (date, param, format, item) {
    var a = moment.tz(date, param);
    var dateFormat = format;
    var weekDay = $(item).data('day' + a.day());
    var labelNext = $(item).data('datelabel');
    var day = a.date() < 10 ? '0' + a.date() : a.date();
    var month = a.month() < 10 ? '0' + (a.month() + 1) : (a.month() + 1);
    var year = a.year();
    dateFormat = dateFormat.replace('dd', day);
    dateFormat = dateFormat.replace('mm', month);
    dateFormat = dateFormat.replace('yyyy', year);
    labelNext = labelNext.replace('{0}', weekDay);
    labelNext = labelNext.replace('{1}', dateFormat);
    var obj = {};
    obj.completeLabel = labelNext;
    obj.zoneAbbr = a.zoneAbbr();
    return obj;
};
function sortSlot () {
    $(document).find('.cc-slots').each(function() {
        $(this).find('.cc-slot').sort(function(a, b) {
            return timeToSeconds(a.dataset.converthour) - timeToSeconds(b.dataset.converthour);
        }).appendTo($(this));
    });
}
function timeToSeconds(time) {
    time = time.split(/:/);
    return time[0] * 3600 + time[1] * 60;
}

function setTabindexOnFocusout() {
    $('.btn').on( "focusout", function() {
        setTimeout(function () {
            $('.btn').attr('tabindex', "0");
        }, 100);
    });
}


module.exports = {  
    
    fixSelectPickerTabindex: setTabindexOnFocusout(),

    handleAttributesForAccessibility: function(){
        document.getElementById("appointment-country").removeAttribute("maxlength");
        document.getElementById("appointment-country").removeAttribute("value");
        document.getElementById("appointment-country").removeAttribute("aria-required");
        document.getElementById("appointment-country").removeAttribute("required");

        var button = document.querySelector('[data-id="appointment-country"]');
        button.setAttribute('aria-controls', 'appointment-country');

    },

    scrollNextOnSkipSection: function(){
        $(document).on('click', '.js-scroll-appointment-next-section', function (e) {
            e.preventDefault(); // Prevent default anchor behavior
            var target = e.target.getAttribute('href'); // Get the target section ID from the href attribute
            var section = document.querySelector(target); 
            var headerHeight = document.querySelector('header').offsetHeight; // get Height of the Header
            var y = section.getBoundingClientRect().top + window.pageYOffset - headerHeight; // Get position of the element considering the Header height
            window.scrollTo({top: y, behavior: 'smooth'}); // Scroll to element
            var id = e.target.getAttribute('id'); // Get the element id attributfe
            let sectionSplitted = id.split("-"); // Split the string using the "-"
            let incremented = parseInt(sectionSplitted[1]) + 1; // Increment the last element by 1
            let nextSection = sectionSplitted[0] + "-" + incremented // Create new string by concatenating "skipSection"+"-"+"NEXT_NUMBER"
            // Set focus to the next section
            if(document.getElementById(nextSection)){
                document.getElementById(target.split("#")[1]).focus();
            } else {
                $(document).find('.cc-input.js-email-footer').focus();
            }
        });

        $(document).on('keydown', ".js-scroll-appointment-next-section", function(e) {
            if (e.shiftKey && e.key === 'Tab') {
                e.preventDefault(); // Prevent default anchor behavior
                var id = e.target.getAttribute('id'); // Get the element id attribute
                let sectionSplitted = id.split("-"); // Split the string using the "-"
                let decremented = parseInt(sectionSplitted[1]) - 1; // Decrement the last element by 1
                let previousSection = sectionSplitted[0] + "-" + decremented // Create new string by concatenating "skipSection"+"-"+"NEXT_NUMBER"
                if(document.getElementById(previousSection)){
                    var section = document.querySelector("#"+previousSection); 
                    var headerHeight = document.querySelector('header').offsetHeight; // get Height of the Header
                    var y = section.getBoundingClientRect().top + window.pageYOffset - headerHeight; // Get position of the element considering the Header height
                    window.scrollTo({top: y, behavior: 'smooth'}); // Scroll to element
                    document.getElementById(previousSection).focus();
                } else {
                    // Set the focus on date
                    document.getElementById("appointment-when").focus();
                }
            }
        });
    },
    addToCalendar: function() {
        $(document).on('click', '.js-add-to-calendar', function (e) {
            dataLayer.push({
                event: 'custom_event',
                eventCategory: 'exclusive-service',
                eventAction: 'boutique-appointment',
                eventLabel: 'step3-add-to-calendar'
            });
            e.stopPropagation();
        });
    },
    callBoutique: function() {
        $(document).on('click', '.js-boutique-call', function (e) {
            dataLayer.push({
                event: 'custom_event',
                eventCategory: 'exclusive-service',
                eventAction: 'boutique-appointment',
                eventLabel: 'step3-contact-boutique'
            });
            e.stopPropagation();
        });
    },
    setTimeZone: function() {
        $(document).ready(function() {
            var datePickerdate = new Date();
            datePickerdate.setDate(datePickerdate.getDate() + 1);
            var endDate = new Date();
            endDate.setMonth(endDate.getMonth() + 6);
            $('.js-datepicker').datepicker('setStartDate', datePickerdate);
            $('.js-datepicker').datepicker('setEndDate', endDate);
            if ($(document).find('.js-update-userTimeZone').length > 0) {
                var date = new Date();
                var isoString = date.toISOString();
                var a = moment.tz.guess();
                var b = moment.tz(isoString, a);
                var abbr = b.zoneAbbr();
                var timeOffset = (-1) * (date.getTimezoneOffset() / 60);
                var offset = (timeOffset >= 0) ? ('+' + timeOffset) : timeOffset;
                var url = $(document).find('.js-update-userTimeZone').data('url');
                $.spinner().start();
                $.ajax({
                    url: url,
                    type: 'GET',
                    data: {
                        abbr: abbr,
                        offset: offset
                    },
                    success: function (data) {
                        if (data.timeZoneHtml) {
                            $(document).find('.js-update-userTimeZone .cc-label').after(data.timeZoneHtml);
                            $(document).find('#userTime-zone').selectpicker('refresh');
                        }
                        $.spinner().stop();
                    },
                    error: function (err) {
                        $.spinner().stop();
                    }
                });
            }
        });
    },
    showDatePicker: function() {
        $('select#appointment-country').on('changed.bs.select', function (e, clickedIndex, newValue, oldValue) {
            if ($('.js-check-date').hasClass('d-none')) $('.js-check-date').removeClass('d-none');
            $(document).find('.js-check-date input#appointment-when').val('');
            $(document).find('.js-upload-boutiqueResult').addClass('d-none');
        });
    },
    modifyDate: function() {
        $(document).on('click', '.js-modyfy-date', function () {
            $(document).find('.js-confirmation-detail-template').addClass('d-none');
            $(document).find('.js-checkcustomer-form').addClass('d-none');
            $(document).find('.js-detail-notSelected').removeClass('d-none');
            $(document).find('.js-upload-boutiqueResult').removeClass('d-none');
            $(document).find('.js-userdataForm').remove();
            $(document).find('.js-appointment-resetPwd-Form').remove();
            $(document).find('.js-appointmentLogin').remove();
            $([document.documentElement, document.body]).animate({
                scrollTop: $('.js-upload-boutiqueResult').offset().top - 60
            }, 0);
        });
    },
    GetBoutiqueAppointment: function() {
        $(document).on('change', '#appointment-when, fieldset.js-line-boutique, #userTime-zone, #appointment-language', function() {
            var $form = $(this).closest('form');
            var url = $form.attr('action');
            var $date = $(document).find('#appointment-when');
            var videoAppointment = false;
            var timeZone = null;
            var startCall = ($date.val() !== '');
            if ($(document).find('#userTime-zone').length > 0) {
                videoAppointment = true;
                timeZone = $(document).find('#userTime-zone').val();
                startCall = ($date.val() !== '' && timeZone !== null);
            }
            if (startCall) {
                var completedate = $date.datepicker('getDate');
                var range = $date.data('range');
                var startTime, endTime;
                var year = completedate.getFullYear();
                var month = completedate.getMonth();
                var day = +completedate.getDate() + +range;
                var time = new Date(year, month, day, 23, 59);
                if (!videoAppointment) {
                    startTime = toIsoString(completedate, null);
                    endTime = toIsoString(time, null);
                } else {
                    var offSet = $(document).find('#userTime-zone option:selected').val();
                    startTime = toIsoString(completedate, offSet);
                    endTime = toIsoString(time, offSet);
                };
                $(document).find('#endDate').val(endTime);
                $(document).find('#startDate').val(startTime);
                $.spinner().start();
                $.ajax({
                    url: url,
                    type: 'POST',
                    data: $form.serialize(),
                    success: function (data) {
                        var $boutiqueUploas = $(document).find('.js-upload-boutiqueResult');
                        if (data.success && data.boutiquesResultHtml) {
                            $boutiqueUploas.removeClass('d-none').empty().html(data.boutiquesResultHtml);
                        } else if (data.success && data.saResultHtml) {
                            $boutiqueUploas.removeClass('d-none').empty().html(data.saResultHtml);
                        }

                        $(document).find('.cc-slots .js-select-slot').each(function () {
                            var date = $(this).data('starttime');
                            var param = $(this).data('gmt');
                            var boutiqueCity = $(this).data('city');
                            var hour;
                            if (data.boutiquesResultHtml) {
                                var obj = checkDST(date, param);
                                hour = obj.hour;
                                $(this).attr('data-gmtlabel', obj.zoneAbbr);
                                $(this).data('gmt', obj.offset);
                            } else {
                                hour = trasformHour(date, param);
                            }
                            $(this).html(hour);
                            $(this).closest('.cc-slot').attr('data-converthour', hour);
                            var ariaLabel = $(this).attr('aria-label').replace('{0}', hour);
                            // ariaLabel.replace('{1}', hour);
                            if (boutiqueCity) {
                                ariaLabel = ariaLabel.replace('{1}', boutiqueCity);
                            }
                            $(this).attr('aria-label', ariaLabel);
                        });
                        sortSlot();
                        $(document).find('.js-label-nextDate').each(function () {
                            var date = $(this).data('next');
                            var param = $(this).data('gmt');
                            var fomat = data.format;
                            var obj = nextDateLabel(date, param, fomat, this);
                            var label = $(this).find('.cc-next-date').text();
                            var replaceLabel = label.replace('{0}', obj.completeLabel);
                            $(this).find('.cc-next-date').html(replaceLabel);
                        });
                        
                        //r Removed for accessibility
                        //let focusableNodes = $boutiqueUploas.find(FOCUSABLE).toArray().filter((n) => { return n.offsetParent; });
                        //if (focusableNodes.length > 0) focusableNodes[0].focus();
                        
                        // set dinamically margin
                        if ($('body').hasClass('cc-mobile') && $(document).find('.cc-slot').length > 0) {
                            var count = parseInt(($(document).find('.cc-slots').width()) / $(document).find('.cc-slot').width()) - 1;
                            var margin = ($(document).find('.cc-slots').width() - count * $(document).find('.cc-slot').width()) / count;
                            $('.cc-slot').css('margin-right', margin);
                        }
                        $.spinner().stop();
                        var pageSubCategory = $('.pagesubCategory').text();
                        dataLayer.push({
                            event: 'dynamic_page',
                            pageCategory: 'exclusive-service',
                            pagesubCategory: pageSubCategory,
                            pageDetail: 'step1-boutique'
                        });                        
                    },
                    error: function (err) {
                        $.spinner().stop();
                    }
                });
            }
        });
    },
    SelectSlot: function() {
        $(document).on('click', '.js-select-slot', function() {
            // Check if there is an element in the DOM with the class cc-slot-btn.js-select-slot.cc-active
            var activeSlot = $('.cc-slot-btn.js-select-slot.cc-active');
            if (activeSlot.length) { activeSlot.attr('aria-checked', 'false'); } // If it exists, set aria-selected to false
            // Then remove the class cc-active from all elements with the class js-select-slot
            $('.js-select-slot').removeClass('cc-active');
            var boutiqueID = $(this).data('boutiqueid');
            $(document).find('.js-nextStep').each(function () {
                if (!$(this).hasClass('d-none') && $(this).data('boutiqueid') !== boutiqueID) {
                    $(this).addClass('d-none');
                    return false;
                }
            });
            $(this).closest('.cc-item').find('.js-nextStep').removeClass('d-none');
            //$(this).closest('.cc-item').find('button.js-confirm-detail').focus(); // Removed for Accessibility issues
            
            $(this).addClass('cc-active'); // Add the class cc-active to the clicked element
            $(this).attr('aria-checked', 'true'); // Set aria-selected to true on the clicked element

        });
    },
    confirmSelectedSlot: function() {
        $(document).on('click', '.js-confirm-detail', function() {
            var boutiqueId = $(this).data('boutiqueid');
            var url = $(this).data('action');
            var country = $(document).find('#appointment-country').val();
            var completeDate = $(document).find('#appointment-when').datepicker('getDate');
            var date = $(document).find('#appointment-when').val();
            var $slot = $(this).closest('.cc-item').find('.js-select-slot.cc-active');
            var dataSlot = JSON.stringify($slot.data('slot'));
            var slotTime = $slot.text();
            var gmtParams = $slot.data('gmt');
            var preference = $(document).find('.cc-card-body fieldset input:checked').val();
            var video = ($(document).find('#userTime-zone').length > 0);
            var language = ($(document).find('#appointment-language').length > 0) ? $(document).find('#appointment-language').val() : null;
            var timezoneLabel;
            if ($(document).find('#userTime-zone').length > 0) {
                timezoneLabel = $(document).find('#userTime-zone :selected').data('id');
            } else {
                timezoneLabel = $slot.data('gmtlabel');
            };
            $.spinner().start();
            $.ajax({
                url: url,
                type: 'POST',
                data: {
                    boutiqueId: boutiqueId,
                    country: country,
                    date: date,
                    completeDate: completeDate,
                    slot: dataSlot,
                    slotTime: slotTime,
                    preference: preference,
                    gmt: gmtParams,
                    video: video,
                    language: language,
                    timezoneLabel: timezoneLabel
                },
                success: function (data) {
                    if (!$('.js-detail-notSelected').hasClass('d-none')) $('.js-detail-notSelected').addClass('d-none');
                    if (!$('.js-upload-boutiqueResult').hasClass('d-none')) $('.js-upload-boutiqueResult').addClass('d-none');
                    $(document).find('.js-confirmation-detail-template').removeClass('d-none').empty().html(data.confirmationDetailHtml);
                    if ($(document).find('.js-confirmation-detail-template').hasClass('d-none')) {
                        $(document).find('.js-confirmation-detail-template').removeClass('d-none');
                    };
                    if (data.formHtml !== null) {
                        $(document).find('.js-check-customer-email').html(data.formHtml);
                        $(document).find('.js-check-customer-email').removeClass('d-none');
                        if ($(document).find('.js-update-customerForm').hasClass('d-none')) {
                            $(document).find('.js-update-customerForm').removeClass('d-none');
                        }
                        setButtonAttribute();
                    } else {
                        if ($(document).find('.js-update-customerForm').hasClass('d-none')) {
                            $(document).find('.js-update-customerForm').removeClass('d-none');
                        }
                        $(document).find('.js-check-customer-email').removeClass('d-none');
                        $(document).find('.js-check-customer-email').closest('.cc-card-container').find('.cc-card-head').addClass('cc-card-head-active');
                        $(document).find('.js-checkcustomer-form').removeClass('d-none');
                    }
                    $(document).find('#slot-form-upload').val(data.slot);
                    $(document).find('#boutiqueID-form-upload').val(data.boutiqueID);
                    $([document.documentElement, document.body]).animate({
                        scrollTop: $('.js-update-customerForm').offset().top - 60
                    }, 0);
                    let focusableNodes = $('.js-update-customerForm').find(FOCUSABLE).toArray().filter((n) => { return n.offsetParent; });
                    if (focusableNodes.length > 0) focusableNodes[0].focus();
                    $.spinner().stop();
                    var pageSubCategory = $('.pagesubCategory').text();
                    if (!data.isLogged) {
                        if (video) {
                            dataLayer.push({
                                event: 'dynamic_page',
                                pageCategory: 'exclusive-service',
                                pagesubCategory: pageSubCategory,
                                pageDetail: 'step2-contact'
                            });
                        } else {
                            dataLayer.push({
                                event: 'dynamic_page',
                                pageCategory: 'exclusive-service',
                                pagesubCategory: 'boutique-appointment',
                                pageDetail: 'step2-email'
                            });
                        }
                    } else {
                        dataLayer.push({
                            event: 'dynamic_page',
                            pageCategory: 'exclusive-service',
                            pagesubCategory: pageSubCategory,
                            pageDetail: 'step2-contact'
                        });
                    }
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },
    checkCustomerEmailByLogin: function() {
        $(document).on('click', '.js-check-email-customer-login', function(e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            var action = $(this).attr('href');
            var country = $(document).find('#appointment-country').val();
            var boutiqueID = $(document).find('.js-upload-boutiqueResult .js-select-slot.cc-active').data('boutiqueid');
            var date = $(document).find('#appointment-when').val();
            var $slot = $(document).find('.js-upload-boutiqueResult .js-select-slot.cc-active');
            var gmt = $slot.data('gmt');
            var preference = $(document).find('.cc-card-body fieldset input:checked').val();
            var slotData = JSON.stringify($slot.data('slot'));
            var email = $(document).find('#appointment-login-form-email').val();
            var guest = ($(this).find('.js-check-email-customer-login').data('guestprosegue') !== false);
            $.spinner().start();
            $.ajax({
                url: action,
                type: 'POST',
                data: {
                    email: email,
                    guest: guest,
                    boutiqueID: boutiqueID,
                    date: date,
                    slot: slotData,
                    country: country,
                    preference: preference,
                    gmt: gmt
                },
                success: function (data) {
                    dataLayer.push({
                        event: 'custom_event',
                        eventCategory: 'exclusive-service',
                        eventAction: 'boutique-appointment',
                        eventLabel: 'step2-proceed-as-guest'
                    });
                    $(document).find('.js-checkcustomer-form').addClass('d-none');
                    if ($(document).find('.js-appointmentLogin').length > 0) $(document).find('.js-appointmentLogin').remove();
                    $(document).find('.js-checkcustomer-form').after(data.formHtml);
                    $(document).find('#appointmentEmail').val(data.email);
                    setButtonAttribute();
                    let focusableNodes = $('.js-checkcustomer-form').find(FOCUSABLE).toArray().filter((n) => { return n.offsetParent; });
                    if (focusableNodes.length > 0) focusableNodes[0].focus();
                    var $grecaptcha = $('form#appointment .js-captcha-form.lazyloading');
                    if ($grecaptcha.length) {
                        document.body.dispatchEvent(new CustomEvent('grecaptcha-load', {detail: $grecaptcha}));
                    }
                    $.spinner().stop();
                    var pageSubCategory = $('.pagesubCategory').text();
                    dataLayer.push({
                        event: 'dynamic_page',
                        pageCategory: 'exclusive-service',
                        pagesubCategory: pageSubCategory,
                        pageDetail: 'step2-contact'
                    });
                },
                error: function (err) {
                    $.spinner().stop();
                }
            });
        });
    },
    checkCustomerEmail: function() {
        $('form.js-checkcustomer-form').submit(function(e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            var action = $(this).attr('action');
            var country = $(document).find('#appointment-country').val();
            var boutiqueID = $(document).find('.js-upload-boutiqueResult .js-select-slot.cc-active').data('boutiqueid');
            var date = $(document).find('#appointment-when').val();
            var $slot = $(document).find('.js-upload-boutiqueResult .js-select-slot.cc-active');
            var gmt = $slot.data('gmt');
            var preference = $(document).find('.cc-card-body fieldset input:checked').val();
            var slotData = JSON.stringify($slot.data('slot'));
            if ($(this).data('href')) {
                action = $(this).data('href');
            }
            var email = $(document).find('#appointment-login-form-email').val();
            var guest = ($(this).find('.js-check-email-customer').data('guestprosegue') !== false);
            $.spinner().start();
            $.ajax({
                url: action,
                type: 'POST',
                data: {
                    email: email,
                    guest: guest,
                    boutiqueID: boutiqueID,
                    date: date,
                    slot: slotData,
                    country: country,
                    preference: preference,
                    gmt: gmt
                },
                success: function (data) {
                    $(document).find('.js-checkcustomer-form').addClass('d-none');
                    if ($(document).find('.js-appointmentLogin').length > 0) $(document).find('.js-appointmentLogin').remove();
                    $(document).find('.js-checkcustomer-form').after(data.formHtml);
                    $(document).find('#appointmentEmail').val(data.email);
                    setButtonAttribute();
                    let focusableNodes = $('.js-checkcustomer-form').find(FOCUSABLE).toArray().filter((n) => { return n.offsetParent; });
                    if (focusableNodes.length > 0) focusableNodes[0].focus();
                    if (data.isGuest) {
                        dataLayer.push({
                            event: 'custom_event',
                            eventCategory: 'exclusive-service',
                            eventAction: 'boutique-appointment',
                            eventLabel: 'step2-proceed-as-guest'
                        });
                        var pageSubCategory = $('.pagesubCategory').text();
                        dataLayer.push({
                            event: 'dynamic_page',
                            pageCategory: 'exclusive-service',
                            pagesubCategory: pageSubCategory,
                            pageDetail: 'step2-contact'
                        });
                    } else {
                        dataLayer.push({
                            event: 'dynamic_page',
                            pageCategory: 'exclusive-service',
                            pagesubCategory: 'boutique-appointment',
                            pageDetail: 'step2-recogniseduser'
                        });
                    }
                    $([document.documentElement, document.body]).animate({
                        scrollTop: $('.js-update-customerForm').offset().top - 60
                    }, 0);

                    var $grecaptcha = $('form#appointment .js-captcha-form.lazyloading');
                    if ($grecaptcha.length) {
                        document.body.dispatchEvent(new CustomEvent('grecaptcha-load', {detail: $grecaptcha}));
                    }

                    $.spinner().stop();
                },
                error: function (err) {
                    $.spinner().stop();
                }
            });
        });
    },
    forgotPassword: function() {
        $(document).on('click', '.js-appointment-reset-pwd-btn', function() {
            var url = this.dataset.urlreset;
            var $loginForm = $('.js-appointmentLogin');
            var $resetPwdForm = $('.js-appointment-resetPwd-Form');
            $.spinner().start();
            $.ajax({
                url: url,
                type: 'GET',
                success: function (data) {
                    $loginForm.addClass('d-none');
                    $resetPwdForm.removeClass('d-none');
                    $.spinner().stop();
                }
            });
        });
        $(document).on('click', '.js-return-toLogin', function() {
            var $loginForm = $('.js-appointmentLogin');
            var $resetPwdForm = $('.js-appointment-resetPwd-Form');
            $loginForm.removeClass('d-none');
            $resetPwdForm.addClass('d-none');
        });
        $(document).on('click', '.js-appointment-resetPwd-request', function (e) {
            var form = $(this).closest('form');
            e.preventDefault();
            var url = form.attr('action');
            form.spinner().start();
            $('form.js-appointment-resetPwd-Form').trigger('resetpwd:submit', e);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    form.spinner().stop();
                    if (data.success) {
                        $('form.js-appointment-resetPwd-Form').empty().html(
                            '<div class="cc-response-message">' +
                            '<p class="cc-succes-text-message">' + data.receivedMsgHeading + '</p>' +
                            '<p class="cc-succes-istruction">' + data.receivedMsgBody + '</p></div>' +
                            '<div class="cc-content-button">' +
                                '<button class="cc-button-primary js-appointment-goto-login"  data-url="' + data.returnUrl + '" aria-label="' + data.btnText + '">' +
                                    data.btnText +
                                '</button>' +
                            '</div>'
                        );
                    } else {
                        $('form.cc-resetPwd').find('#appointmentForgotPasswordemail').addClass('cc-error');
                        $('form.cc-resetPwd').find('.cc-feedback-message .cc-text-message-error').empty().html(data.loginEmail);
                        $('#appointmentForgotPasswordemail').focus();
                    }
                },
                error: function (data) {
                }
            });
            return false;
        });
        $(document).on('click', '.js-appointment-goto-login', function(e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            $.spinner().start();
            window.location.href = $(this).data('url');
        });
    },
    appointmentLogin: function () {
        $(document).on('submit', 'form#js-appointment-login-form', function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            var form = $(this);
            var url = form.attr('action');
            form.spinner().start();
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    if (data.success) {
                        dataLayer.push({
                            event: 'custom_event',
                            eventCategory: 'exclusive-service',
                            eventAction: 'boutique-appointment',
                            eventLabel: 'step2-login'
                        });
                        $(document).find('.js-appointmentLogin').remove();
                        $(document).find('.js-check-customer-email').html(data.formHtml);
                        setButtonAttribute();
                        var pageSubCategory = $('.pagesubCategory').text();
                        dataLayer.push({
                            event: 'dynamic_page',
                            pageCategory: 'exclusive-service',
                            pagesubCategory: pageSubCategory,
                            pageDetail: 'step2-contact'
                        });
                    } else {
                        formValidation(form, data);
                        $('form.js-appointmentLogin').trigger('login:error', data);
                    }
                    let focusableNodes = $('.js-appointmentLogin').find(FOCUSABLE).toArray().filter((n) => { return n.offsetParent; });
                    if (focusableNodes.length > 0) focusableNodes[0].focus();
                    $([document.documentElement, document.body]).animate({
                        scrollTop: $('.js-update-customerForm').offset().top - 60
                    }, 0);
                    form.spinner().stop();
                },
                error: function (data) {
                }
            });
            return false;
        });
    },
    appointmentSubmit: function() {
        $(document).on('submit', 'form#appointment', function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            var form = $(this).closest('form#appointment');
            var url = form.attr('action');
            var shareWishslit = $('#share-wishlist').prop('checked');
            var vid = document.createElement('input');
            vid.setAttribute('type', 'hidden');
            vid.setAttribute('name', 'video');
            var video = ($(document).find('#userTime-zone').length > 0);
            if (video) {
                vid.setAttribute('value', 'true');
            } else {
                vid.setAttribute('value', 'false');
            }
            var gmtLabel = document.createElement('input');
            gmtLabel.setAttribute('type', 'hidden');
            gmtLabel.setAttribute('name', 'gmtLabel');
            var label = '';
            if (video) {
                label = $(document).find('#userTime-zone :selected').data('id');
                gmtLabel.setAttribute('value', label);
            } else {
                label = $(document).find('.js-upload-boutiqueResult .js-select-slot.cc-active').data('gmtlabel');
                gmtLabel.setAttribute('value', label);
            }
            var occasionName = $('#appointmentUse').find(':selected').val();
            occasionName = occasionName.toLowerCase().replace(/\s/g, '_');
            form.append(vid);
            form.append(gmtLabel);
            var checkHoneyPot = $('.contact_me_if_spam').val();
            var isSpam = checkHoneyPot.length > 0 ? true : false;

            const readyToSubmit = $.Deferred();
            if (navigationCountry === 'CN') {
                var $tencentCaptcha = $('.js-tencent-captcha-container', form);
                TencentCaptcha.initialize($tencentCaptcha, readyToSubmit);
            } else {
                readyToSubmit.resolve();
            }

            readyToSubmit.done(function() {
                if (!isSpam) {
                    form.spinner().start();
                    var lineType = $('.js-line-boutique').find('input:checked').attr('id').split('appointment-')[1].replace('-', ' and ').toLowerCase();
                    $.ajax({
                        url: url,
                        type: 'post',
                        dataType: 'json',
                        data: form.serialize(),
                        success: function (data) {
                            if (data.success) {
                                $(document).find('.js-appointment').remove();
                                $(document).find('.js-appointment-confirmation').html(data.confirmationHtml);
                                $(document).find('.js-appointment-confirmation').removeClass('d-none');
                                if (data.videoHtml) {
                                    $(document).find('.js-upload-video-img').html(data.videoHtml);
                                };
                                $(document).find('.js-upload-info-asset').html(data.assetInfo);
                                var appointmentDate = data.confirmation.appointment[0].SchedStartTime.split('T')[0];
                                appointmentDate = appointmentDate.split('-').reverse().join('/');
                                var pageSubCategory = $('.pagesubCategory').text();
                                if (pageSubCategory === 'virtual-appointment') {
                                    dataLayer.push ({
                                        event: 'dynamic_page',
                                        pageCategory: 'exclusive-service',
                                        pagesubCategory: pageSubCategory,
                                        appointmentBoutique: 'virtual',
                                        appointmentLine: lineType,
                                        appointmentOccasion: occasionName,
                                        appointmentDate: appointmentDate,
                                        appointmentWishlist: shareWishslit,
                                        pageDetail: 'step3-complete'
                                    });
                                } else {
                                    dataLayer.push ({
                                        event: 'dynamic_page',
                                        pageCategory: 'exclusive-service',
                                        pagesubCategory: pageSubCategory,
                                        boutiqueName: data.confirmation.boutique.name + '–' + data.confirmation.boutique.ID,
                                        appointmentLine: lineType,
                                        appointmentOccasion: occasionName,
                                        appointmentDate: appointmentDate,
                                        appointmentWishlist: shareWishslit,
                                        pageDetail: 'step3-complete'
                                    });
                                }
                                $([document.documentElement, document.body]).animate({
                                    scrollTop: $('.js-appointment-confirmation').offset().top - 80
                                }, 0);
                            } else {
                                $(document).find('.js-userdataForm').empty().html(data.errorLabel);
                            }
                            if ($(document).find('.js-scroll-confirmation-template').length > 0) {
                                $([document.documentElement, document.body]).animate({
                                    scrollTop: $('.js-scroll-confirmation-template').offset().top - 80
                                }, 0);
                            } else {
                                $([document.documentElement, document.body]).animate({
                                    scrollTop: $('.js-appointment').offset().top - 80
                                }, 0);
                            }
                            form.spinner().stop();
                        },
                        error: function (data) {
                            form.spinner().stop();
                        }
                    });
                }
            });
        });
    }
};
